import { Box, IconButton, Input, InputAdornment } from '@mui/material';
import GoIcon from '@mui/icons-material/Forward';
import { useCallback, useMemo, useState } from 'react';
import { cellToBoundary } from 'h3-js';
import bbox from '@turf/bbox';
import * as turf from '@turf/helpers';
import GoogleMap from '../../components/google/maps/Map';
import { useGrowers } from '../../hooks/use-growers';

export function Map() {
  const { selectedId: growerId } = useGrowers();
  const [goTo, setGoTo] = useState('');
  const [bounds, setBounds] = useState();

  const filters = useMemo(
    () => ({ growerId: growerId || '00000000-0000-0000-0000-000000000000' }),
    [growerId],
  );

  const go = useCallback(() => {
    try {
      setBounds(bbox(turf.polygon([cellToBoundary(goTo, true)])));
    } catch (e) {
      // not an h3 cell
    }
  }, [goTo]);

  const getControls = useCallback(
    () => (
      <Box sx={{ m: 1, position: 'relative' }}>
        <Input
          value={goTo}
          onChange={(e) => setGoTo(e.target.value)}
          sx={{ px: 1, py: 0.4, bgcolor: 'white', pointerEvents: 'auto' }}
          placeholder="Go to H3 cell..."
          endAdornment={
            <InputAdornment position="end">
              <IconButton edge="end" onClick={go} disabled={!goTo}>
                <GoIcon />
              </IconButton>
            </InputAdornment>
          }
        />
      </Box>
    ),
    [go, goTo],
  );

  return (
    <GoogleMap bounds={bounds} filters={filters} getControls={getControls} />
  );
}
